import { render, staticRenderFns } from "./secondHeader.vue?vue&type=template&id=4ff51d96&scoped=true"
import script from "./secondHeader.vue?vue&type=script&lang=js"
export * from "./secondHeader.vue?vue&type=script&lang=js"
import style0 from "./secondHeader.vue?vue&type=style&index=0&id=4ff51d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff51d96",
  null
  
)

export default component.exports